export class WorkOrderModel{
  workOrderId:number;
  redliningId:number;
  projectNumber:string;
  user:string
}
